import { render } from "./WaitersView.vue?vue&type=template&id=fa56cb76"
import script from "./WaitersView.vue?vue&type=script&lang=js"
export * from "./WaitersView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__